const styles = (theme) => ({
  icon: {
    marginLeft: theme.spacing(0.625),
  },
  yellowIcon: {
    '& circle': {
      fill: theme.color.light_brown,
    },
  },
  grayIcon: {
    '& circle': {
      fill: theme.color.light_grey,
    },
  },
});
export default styles;
